import { schema } from 'normalizr';

const reservation = new schema.Entity('reservations', { idAttribute: 'id' });
const arrayOfReservations = new schema.Array(reservation);

const service = new schema.Entity('services', { idAttribute: 'id' });
const item = new schema.Entity('items', { idAttribute: 'id' });
const pendingService = new schema.Entity('pendingServices', { idAttribute: 'id' });
const pendingItem = new schema.Entity('pendingItems', { idAttribute: 'id' });

export const hike = new schema.Entity('hikes', { idAttribute: 'id' });

service.define({
    items: new schema.Array(item),
    hike: hike
});
pendingService.define({
    items: new schema.Array(pendingItem),
    hike: hike
});

reservation.define({
    services: new schema.Array(service),
    pendingServices: new schema.Array(pendingService),
});

export {
    reservation,
    arrayOfReservations
};
